@let language = language$ | async;

<div class="table-container" [class.is-disabled]="isDisabled">
  <div class="table-header">
    <div class="header-cell">{{ 'MTR_COMMON_APPLICATION' | translate }}</div>
    <div class="header-cell">{{ 'MTR_COMMON_FORM_EXPIRATION_DATE' | translate }}</div>
  </div>

  @for (app of applications; track app.id) {
    @let isDesktop = app.isDesktop;
    @let isEnabled = app.enabled;
    <div class="row-wrapper">
      <div class="table-row" [class.expanded-parent]="app.isExpanded">
        <div class="cell app-cell">
          <div class="bo-form__switch">
            <mcui-switch
              class="bo-form__input bo-form__input--inline"
              [ngModel]="isEnabled"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isDisabled"
              (ngModelChange)="onAppStatusChange($event, app)"
            />
            <span [class.is-disabled]="isDisabled">{{ app.name | translate }}</span>
          </div>
        </div>

        <div class="cell app-cell">
          @if (isDesktop && !app.hasLicense) {
            <span class="no-license">{{ 'MTR_COMMON_NO_LICENSE_FOUND' | translate }}</span>
          }
        </div>

        <div
          class="cell date-cell"
          [class.has-error]="isDesktop && isEnabled && !app.license?.expiresAt"
        >
          @if (isDesktop && isEnabled) {
            <bo-calendar
              appendTo="body"
              [showClear]="false"
              [minDate]="currentDate"
              [showTime]="true"
              hourFormat="24"
              [stepMinute]="1"
              [ngModel]="app.license?.expiresAt"
              [language]="language"
              (ngModelChange)="updateExpirationDate($event, app)"
            />
          }
        </div>
      </div>

      @if (isDesktop && app.isExpanded) {
        <div class="table-sub-row">
          <div class="connection-line"></div>

          <div class="sub-row-content">
            <div class="sub-option">
              <mcui-switch
                class="bo-form__input bo-form__input--inline"
                [ngModel]="app.license?.features?.refereeMode"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isDisabled"
                (ngModelChange)="updateDesktopRefereeMode($event, app)"
              />
              <span [class.is-disabled]="isDisabled">
                {{ 'MTR_COMMON_FORM_REFEREE_MODE' | translate }}
              </span>
            </div>
            <div class="sub-option">
              <bo-stepper
                [ngModel]="app.offlineHours"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isDisabled"
                [step]="1"
                (ngModelChange)="updateDesktopOfflineHours($event, app)"
              />
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
